
import React,{useState} from "react";
import { Card, CardBody, Table, Button, Badge, Spinner, } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import useTasks from "../../Hooks/useTasks";
import TaskCommentsModal from "../../components/Tasks/TaskCommentsModal";
const Index=()=>{
  const [modal,setModal]=useState(false);
  const { tasks, loading, completeTask, }=useTasks();

  return(
    <div className="page-content">
      <Breadcrumbs title="CRM" breadcrumbItem="Tasks" />
      <Card>
        <CardBody>
          <div className="table-responsive">
            <Table className="align-middle">
              <thead>
                <tr>
                  <th>Task</th>
                  <th>Lead</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr> <td colSpan="4" className="text-center" > <Spinner size="sm"/> </td>
                  </tr>
                ) : tasks.length===0 ? (
                  <tr> <td colSpan="4" className="text-center" > No Tasks Found </td> </tr>
                ) : (
                  tasks.map((t)=>(
                    <tr key={t._id}>
                      <td> <div className="fw-semibold"> {t.title} </div> </td>
                      <td> {t?.leadId?.name || "-"} </td>
                      <td> <Badge color={ t.status==="completed" ? "success" : "warning" } > {t.status} </Badge> </td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button size="sm" color="primary" onClick={()=> setModal(true) } >
                            <i className="mdi mdi-message"/>
                          </Button>
                          <Button size="sm" color="success" onClick={()=> completeTask(t._id) } >
                            <i className="mdi mdi-check"/>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <TaskCommentsModal isOpen={modal} toggle={()=>setModal(!modal)} />
    </div>
  );
};

export default Index;
